// src/component/ui/CountUp.jsx
// Compteur qui s'anime de 0 à `end` quand il devient visible (rAF + IntersectionObserver).
import React, { useEffect, useRef, useState } from "react";

export default function CountUp({ end = 0, duration = 1600, prefix = "", suffix = "", decimals = 0 }) {
  const ref = useRef(null);
  const started = useRef(false);
  const [val, setVal] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const start = () => {
      if (started.current) return;
      started.current = true;
      if (reduce) { setVal(end); return; }
      const t0 = performance.now();
      const tick = (t) => {
        const p = Math.min(1, (t - t0) / duration);
        const eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        setVal(end * eased);
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    };
    if (typeof IntersectionObserver === "undefined") { start(); return; }
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) { start(); io.disconnect(); } }),
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [end, duration]);

  const shown = decimals > 0
    ? Number(val).toFixed(decimals)
    : Math.round(val).toLocaleString("fr-FR");

  return <span ref={ref}>{prefix}{shown}{suffix}</span>;
}
